module.exports = __webpack_public_path__ + "static/media/tela1.bc56bca8.png";